import { render, staticRenderFns } from "./TagGroups.vue?vue&type=template&id=e8d5d9c2"
import script from "./TagGroups.vue?vue&type=script&lang=js"
export * from "./TagGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports